import { DeviceDef, LogManager } from "@mcleod/core";
import { MobileDeviceInfo } from "./MobileDeviceInfo";
import { CapacitorAccess } from "../capacitor";

const log = LogManager.getLogger("common.MobileDeviceAccessor");

export class MobileDeviceAccessor implements DeviceDef {
    private static _instance: MobileDeviceAccessor;

    private info: MobileDeviceInfo | undefined;

    private constructor() { this.getInfo(); }

    public static get instance(): MobileDeviceAccessor {
        this._instance ??= new MobileDeviceAccessor();
        return this._instance;
    }

    private async getInfo(): Promise<void> {
        const devicePlugin = CapacitorAccess.plugins?.Device;
        if (devicePlugin) {
            devicePlugin.getInfo().then(
                (deviceInfo) => {
                    this.info = deviceInfo;
                    log.debug(`===Mobile Device Info===
                        Platform: ${deviceInfo.platform}
                        Model: ${deviceInfo.model}
                        Manufacturer: ${deviceInfo.manufacturer}
                        OS: ${deviceInfo.operatingSystem}
                        OSV: ${deviceInfo.osVersion}
                        Virtual: ${deviceInfo.isVirtual}
                        === ===
                    `)
                }
            );
        } else {
            log.error("WARNING: Capacitor Device Plugin undefined.");
        }
    }

    public get browser(): string {
        return "McLeod Mobile";
    }

    public get isVirtual(): boolean {
        return this.info?.isVirtual ?? false;
    }

    public get platform(): string {
        return this.info?.platform;
    }

    public get type(): "phone" | "tablet" | "desktop" {
        return null; // Delegates to DeviceAccessor.
    }

    public static get isAndroidEmulator(): boolean {
        return MobileDeviceAccessor.instance.isVirtual
            && MobileDeviceAccessor.instance.platform === 'android';
    }

    public static get isAppleSimulator(): boolean {
        return MobileDeviceAccessor.instance.isVirtual
            && (MobileDeviceAccessor.instance.platform === 'ios'
                || MobileDeviceAccessor.instance.platform === 'ipad'
                || MobileDeviceAccessor.instance.platform === 'ipod');
    }
}
